module.exports = __webpack_public_path__ + "my.svg?4b3250fd5e2731d364705eb3861ac6dc";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/my.svg
// module id = 891
// module chunks = 27